import React, { FC, useCallback } from 'react';
import { Form, Radio } from 'src/common';
import formStyles from '../index.module.scss';
import styles from './index.module.scss';
import { useTranslation } from 'react-i18next';
import { Space } from 'antd';
import { useSetBidQuestionAnswer, useTask } from 'src/models/bids/BidTask/hooks';
import { FormInstance } from 'antd/lib/form';
import { IAnswerFormState } from '../index';

interface IProps {
  form: FormInstance<IAnswerFormState>;
}

const fieldName = 'yesNo';

export const YesNoAnswer: FC<IProps> = (props: IProps) => {
  const { form } = props;
  const { t } = useTranslation();
  const [setAnswer] = useSetBidQuestionAnswer();
  const { data: task } = useTask();

  const onChange = useCallback(() => {
    if (!!task) {
      const answer = form.getFieldValue(fieldName);

      setAnswer({
        questionId: task.id,
        questionGroupId: task.groupId,
        answer: {
          answer,
          content: task.answer?.content,
          files: task.answer?.files?.map(file => file.id)
        }
      });
    }
  }, [form, task, setAnswer]);

  return (
    <div className={formStyles.unit}>
      <Form.Item name={fieldName}>
        <Radio.Group onChange={onChange}>
          <Space direction={'vertical'}>
            <Radio value={true} key={'yes'} className={styles.radioButton}>
              {t('Common.yes')}
            </Radio>
            <Radio value={false} key={'no'} className={styles.radioButton}>
              {t('Common.no')}
            </Radio>
          </Space>
        </Radio.Group>
      </Form.Item>
    </div>
  );
};

export default YesNoAnswer;
